import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ScrollText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
export function AgreementCTA() {
  const {
    t
  } = useLanguage();
  return <div className="mt-12 text-center" data-id="element-19">
      <p className="text-sm uppercase tracking-widest text-zinc-500 font-medium mb-4" data-id="element-20">
        {t('ctas.agreement.tag')}
      </p>
      <h3 className="font-serif text-2xl md:text-3xl mb-3 text-zinc-100" data-id="element-21">
        {t('ctas.agreement.title')}
      </h3>
      <p className="text-zinc-400 text-base md:text-lg mb-8 italic" data-id="element-22">
        {t('ctas.agreement.subtitle')}
      </p>
      <motion.div animate={{
      boxShadow: ['0 0 0 0 rgba(16, 185, 129, 0.45)', '0 0 0 10px rgba(16, 185, 129, 0)', '0 0 0 0 rgba(16, 185, 129, 0)'],
      scale: [1, 1.01, 1]
    }} transition={{
      duration: 2.8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="inline-block rounded-full" data-id="element-23">
        <Link to="/agreement" className="inline-flex items-center gap-3 px-8 py-3.5 bg-emerald-600 text-white rounded-full font-medium text-base hover:bg-emerald-500 transition-colors group shadow-lg shadow-emerald-600/25" data-id="element-24">
          <ScrollText className="w-5 h-5" data-id="element-25" />
          {t('ctas.agreement.btn')}
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-26" />
        </Link>
      </motion.div>
    </div>;
}